import React from 'react';
import { View, Text, StyleSheet, Modal, TouchableOpacity } from 'react-native';
import { Zap, PlaySquare, Crown, X } from 'lucide-react-native';
// Importiamo il context dei vini per agganciare la localizzazione reattiva
import { useWineContext } from '../context/WineContext';

export default function OutOfEnergyModal({ visible, onClose, onWatchAd, onSubscribe }) {
  const { t } = useWineContext();

  if (!visible) return null;

  return (
    <Modal transparent={true} visible={visible} animationType="slide" onRequestClose={onClose}>
      <View style={styles.modalOverlay}>
        <View style={styles.modalBox}>
          
          {/* Header con icona e chiusura */}
          <View style={styles.modalHeader}>
            <View style={styles.titleRow}>
              <Zap color="#e11d48" size={28} fill="#e11d48" />
              <Text style={styles.modalTitle}>{t('components.outOfEnergy.title')}</Text>
            </View>
            <TouchableOpacity onPress={onClose} style={styles.closeBtn}>
              <X color="#64748b" size={24} />
            </TouchableOpacity>
          </View>

          {/* Testo informativo localizzato */}
          <View style={styles.modalBody}>
            <Text style={styles.modalMessage}>
              {t('components.outOfEnergy.freeAppMsg')}
            </Text>
            <Text style={styles.modalMessage}>
              {t('components.outOfEnergy.systemMsg')}
            </Text>
            <Text style={styles.modalSubTitle}>{t('components.outOfEnergy.resumeAnalysis')}</Text>
          </View>

          {/* CTA 1: Guarda il video (Primaria) */}
          <TouchableOpacity style={styles.videoOptionBtn} onPress={onWatchAd} activeOpacity={0.8}>
            <PlaySquare color="#0f172a" size={28} style={{marginRight: 14}} />
            <View style={{flex: 1}}>
              <Text style={styles.optionTitle}>{t('components.outOfEnergy.watchShortAd')}</Text>
              <Text style={styles.optionSub}>{t('components.outOfEnergy.refillFreeSub')}</Text>
            </View>
          </TouchableOpacity>

          {/* CTA 2: Abbonamento PRO (Secondaria) */}
          <TouchableOpacity style={styles.proOptionBtn} onPress={onSubscribe} activeOpacity={0.8}>
            <Crown color="#d97706" size={24} style={{marginRight: 14}} />
            <View style={{flex: 1}}>
              <Text style={styles.optionTitlePro}>{t('components.outOfEnergy.upgradeProTitle')}</Text>
              <Text style={styles.optionSubPro}>{t('components.outOfEnergy.upgradeProSub')}</Text>
            </View>
          </TouchableOpacity>

        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalOverlay: { 
    flex: 1, 
    backgroundColor: 'rgba(15, 23, 42, 0.75)', 
    justifyContent: 'center', 
    alignItems: 'center', 
    padding: 20 
  },
  modalBox: { 
    backgroundColor: '#ffffff', 
    borderRadius: 24, 
    padding: 24, 
    width: '100%', 
    maxWidth: 420, 
    elevation: 10,
    boxShadow: '0px 10px 25px rgba(0,0,0,0.2)' 
  },
  modalHeader: { 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    marginBottom: 20 
  },
  titleRow: { 
    flexDirection: 'row', 
    alignItems: 'center' 
  },
  modalTitle: { 
    fontSize: 22, 
    fontWeight: 'bold', 
    color: '#0f172a', 
    marginLeft: 10 
  },
  closeBtn: { 
    padding: 6, 
    backgroundColor: '#f1f5f9', 
    borderRadius: 20 
  },
  modalBody: { 
    marginBottom: 20 
  },
  modalMessage: { 
    fontSize: 16, 
    color: '#475569', 
    lineHeight: 24, 
    marginBottom: 12 
  },
  modalSubTitle: { 
    fontSize: 16, 
    fontWeight: 'bold', 
    color: '#0f172a', 
    marginTop: 8 
  },
  videoOptionBtn: { 
    flexDirection: 'row', 
    alignItems: 'center', 
    backgroundColor: '#f8fafc', 
    padding: 16, 
    borderRadius: 16, 
    borderWidth: 2, 
    borderColor: '#e2e8f0',
    marginBottom: 12
  },
  optionTitle: { 
    fontSize: 16, 
    fontWeight: 'bold', 
    color: '#0f172a' 
  },
  optionSub: { 
    fontSize: 14, 
    color: '#64748b', 
    marginTop: 2 
  },
  proOptionBtn: { 
    flexDirection: 'row', 
    alignItems: 'center', 
    backgroundColor: '#fffbeb', 
    padding: 16, 
    borderRadius: 16, 
    borderWidth: 1, 
    borderColor: '#fde68a'
  },
  optionTitlePro: { 
    fontSize: 16, 
    fontWeight: 'bold', 
    color: '#b45309' 
  },
  optionSubPro: { 
    fontSize: 14, 
    color: '#d97706', 
    marginTop: 2 
  }
});